import {
  Button as ChakraButton,
  ButtonGroup as ChakraButtonGroup,
  ButtonGroupProps,
  ButtonProps,
  Icon,
} from '@chakra-ui/react';
import { forwardRef, PropsWithChildren } from 'react';

import { Action, IconMenuAction, WrappedAction } from '../actions';
import { ChakraMenuActionItem, ChakraOnClickAction, RenderAction } from './chakra-menu-actions';

export type { ChakraMenuActionItem, ChakraOnClickAction } from './chakra-menu-actions';

export type BulkAction<T = unknown> = Action &
  IconMenuAction &
  Partial<ChakraOnClickAction> &
  Partial<WrappedAction<T>> & { id?: string; buttonProps?: ButtonProps };

export interface WrappedBulkActionState {
  isVisible: boolean;
  onBulkEditorOpenChange(id: string, isOpen: boolean): void;
}

export interface BulkActionButtonsProps<T = unknown> {
  actions: BulkAction<T>[];
  state?: T;
  buttonGroupProps?: ButtonGroupProps;
}

/* Parked with the Table round: the bulk actions are table engine chrome and
 * convert with the bar (component-map.md). */
export const BulkActionButtons = forwardRef<
  HTMLDivElement,
  PropsWithChildren<BulkActionButtonsProps>
>(({ actions, state, buttonGroupProps, children }, ref) => {
  return (
    <ChakraButtonGroup isAttached variant="outline" {...buttonGroupProps} ref={ref}>
      {actions.map((action) => (
        <RenderAction
          key={action.id ?? action.label}
          action={action as ChakraMenuActionItem}
          extra={state}
          tooltipProps={{ placement: 'top' }}
        >
          <ChakraButton
            size="sm"
            fontWeight="normal"
            colorScheme={action.colorScheme}
            isDisabled={action.isDisabled}
            isLoading={action.isLoading}
            leftIcon={<Icon as={action.icon} boxSize="4" />}
            onClick={action.onClick}
            {...action.buttonProps}
          >
            {action.label}
          </ChakraButton>
        </RenderAction>
      ))}
      {children}
    </ChakraButtonGroup>
  );
});
